/**
 * Weight Freeze (v2) — reference data.
 *
 * The app clock. Declared here rather than re-exported from Weight Disputes:
 * the two modules are deliberately independent and neither imports the other,
 * so a re-export in production code would make every freeze-v2 consumer of
 * `NOW` depend on the disputes module. They must still agree on "today" for
 * the same merchant, and `format.test.js` asserts exactly that — a test-only
 * drift guard that fails loudly if either module moves its clock.
 */
export const NOW = new Date('2026-08-07T00:00:00Z')

export const REVIEW_STATE = {
  AWAITING:  'Awaiting Prozo review',
  ADDITIONAL:'Additional data requested',
  SUBMITTED: 'Data submitted — awaiting decision',
  /** Weight v2 (T12/T13): Prozo proposed the weight; it is the MERCHANT's decision, not Prozo's. */
  PROPOSED:  'Proposed by Prozo — your decision needed',
}

export const REJECT_REASON = {
  CONTRADICTORY: 'Contradictory data available',
  COURIER_SIDE:  'Not possible due to courier-side constraints',
  INADEQUATE:    'Additional data inadequate after 3 submissions',
}

export const EVENT_KIND = {
  RAISED: 'RAISED', SUBMITTED: 'SUBMITTED', INFO_REQUESTED: 'INFO_REQUESTED',
  NOTE: 'NOTE', APPROVED: 'APPROVED', DECLINED: 'DECLINED', LIMIT_REACHED: 'LIMIT_REACHED',
  // Live-backend kinds (MerchantWeightFreezeRequest.EventKind): a Prozo withdrawal, an approval
  // replaced by a newer one, and the three steps of an auto-proposal.
  WITHDRAWN: 'WITHDRAWN', SUPERSEDED: 'SUPERSEDED',
  PROPOSED: 'PROPOSED', PROPOSAL_ACCEPTED: 'PROPOSAL_ACCEPTED', PROPOSAL_DECLINED: 'PROPOSAL_DECLINED',
}

/** Who put a request on the table (MerchantWeightFreezeRequest.Source). Seeded data carries none = MERCHANT. */
export const REQUEST_SOURCE = {MERCHANT: 'MERCHANT', PROZO_PROPOSED: 'PROZO_PROPOSED', PROZO_SEEDED: 'PROZO_SEEDED'}

/** T24b — how a switch-over carry-over is described to the merchant. Never shown as their own request. */
export const SEEDED_LABEL = 'Set by Prozo — carried over from your existing courier freeze.'

/** T23 — printed verbatim on every approval; billing follows the per-account switch-on, never the approval date. */
export const APPROVAL_NOTICE = 'Approved. Billing on this weight starts when the new weight rule is switched on for your account.'

/** Stored value is 'Combo'; the LABEL is 'Combination'. Never compare against the label. */
export const FREEZE_LEVEL = {SKU: 'SKU', SUBCAT: 'Sub-category', COMBO: 'Combo'}
export const FREEZE_LEVEL_LABEL = {SKU: 'SKU', 'Sub-category': 'Sub-category', Combo: 'Combination'}

/** PRESENTATION lookup, not a schema field. Assembled from kind + state + cyclesElapsed. */
export const STATUS_TONE = {
  approved: 'ok', review: 'warn', additional: 'info', submitted: 'info',
  rejected: 'danger', none: 'neutral', preliminary: 'ai',
}

/** Business rules from the source document — not tunable config. */
export const RULES = {
  SUBMISSIONS_PER_REQUEST: 3,     // 1 initial + 2 additional
  PRELIMINARY_CYCLES: 2,
  DWS_RETENTION_RECORDS: 10,
  DWS_RETENTION_MONTHS: 6,
  VOLUMETRIC_DIVISOR: 5000,
  PACKING_MATERIAL_BAND: [8, 10],
  WEIGHT_TOLERANCE_KG: 0.005,
}
